<style lang="scss" scoped>
.connect {
	&__header {
		&__steps {
			margin-top: 20px;
		}
	}
	&__row {
		@include grid();
	}
	&__left {
		@include grid-col(4);
		padding-right: 40px;
	}
	&__right {
		@include grid-col(8);
		& ::v-deep .box-card {
			margin-bottom: 30px;
		}
	}
	&__pad-bottom {
		margin-bottom: 30px;
	}
}
</style>

<template lang="pug">
.connect
	app-header
		.connect__header(slot='header')
			h1 Connect to {{ providerFullName }}
			.connect__header__steps
				el-steps(:active='0', finish-status='success')
					el-step(title='Connect')
					el-step(title='Settings')
					el-step(title='Match')
					el-step(title='Classes')
	.container
		.main-panel
			loading(v-if='$apollo.loading')
			.main-panel__padding(v-else='')
				p.mb-0
					| This wizard will help you through the process of setting up your Edusync {{ providerName }}. Once connected you will be able to:
					ul.mt-3
						li Automatically update your {{ providerFullName }} directory when data changes within your management information system (MIS).
						li Automatically place users in the correct year and registration groups.
						li(v-show="providerCode === 'gapps'") Setup SAML integration to allow your students and teachers to login to their {{ providerName }} apps with easy-to-use Edusync passwords.
					| The first step is to connect to your {{ providerFullName }}. 
					strong Don't worry, we won’t modify any of your users until you are ready!
				div(v-if="providerCode === 'msft'")
					p.mb-0
						| To begin, please input your Entra ID Tenant ID below
					el-input(v-model="tenantId")

			.main-panel__padding.connect__section(v-if="providerCode === 'msad'")
				.connect__row
					.connect__left
						h2 Connection Settings
					.connect__right
						el-card.box-card
							.clearfix(slot='header')
								span Host
							el-form(label-position='top')
								el-form-item(label='Active Directory Domain Controller host and port')
									el-input(v-model='form.msad_host')
						el-card.box-card
							.clearfix(slot='header')
								span Credentials
							el-form(label-position='top')
								el-form-item(label='Username')
									el-input(v-model='form.msad_username')
							el-form(label-position='top')
								el-form-item(label='Password')
									el-input(v-model='form.msad_password' type="password")
				el-button(type='primary', :loading='loading', @click='save').actions {{ loading ? "Saving settings..." : "Continue" }}

			.main-panel__footer.text-right(v-else="")
				el-button.mega-action(@click='redirect', type='success') Login to {{ providerName }}
</template>

<script>
import gql from "graphql-tag";
export default {
	data() {
		return {
			auth: null,
			loading: false,
			form: {},
			tenantId: ""
		};
	},

	apollo: {
		auth: {
			query: gql`
				{
					Auth {
						redirect_url
					}
				}
			`,
			update: r => r.Auth
		},
		form: {
			query: gql`
				{
					AdSettings {
						id
						msad_host
						msad_username
						msad_password
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r => {
				const data = _.cloneDeep(r.AdSettings);
				data.msad_password = null;

				return data;
			}
		}
	},

	methods: {
		async redirect() {
			if (this.providerCode === "msft") {
				await this.$apollo
						.mutate({
							mutation: gql`
								mutation SaveSettings($object: SettingsInput!) {
									SaveSettings(object: $object) {
										tenant_id
									}
								}
							`,
							variables: {
								object: {
									tenant_id: this.tenantId
								}
							}
						})
						.catch(e => {
							this.$message.error("Failed to update settings");
						});
				try {
					await this.$apollo.queries.auth.refetch();
				} catch (e) {
					this.$message.error("Invalid tenant ID");
				}
			};

			window.location.replace(this.auth.redirect_url);
			
		},

		next() {
			this.$router.push({ name: "wizard.settings" });
		},

		save() {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: gql`
						mutation SaveAdSettings($object: InputAdSettings!) {
							SaveAdSettings(object: $object) {
								msad_host
								msad_username
								msad_password
							}
						}
					`,
					variables: {
						object: _.pick(this.form, ["msad_host", "msad_username", "msad_password"])
					}
				})
				.then(r => {
					this.loading = false;
					this.$message.success("Active Directory connected");
					this.$router.push({ name: "wizard.settings" });
				})
				.catch(e => {
					this.loading = false;
					this.$message.error("Failed to connect - ensure the host and credentials are correct");
				});
		}
	}
};
</script>
